import dayjs from "dayjs";
import React, { PureComponent } from "react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Line,
    ComposedChart,
    Bar,
    LineChart,
    ReferenceLine,
    Scatter,
    Cell,
    Legend,
} from "recharts";
import nodata from '../../src/assets/images/no-data.png'

export default class TempGraphLiveTracking extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        console.log("temp graph live tracking component")
        console.log(this.props);
    }

    render() {


        const graphData = this.props.TempGraphData || {};
        // const refillData = this.props.fuelRefillData || [];

        // Fuel readings
        const chartData = this.props.TempGraphData.map(item => ({
            timestamp: item.timestamp,
            name: dayjs(item.timestamp).format("HH:mm"),
            temp1: Number(item.temp1 || 0),
            temp2: Number(item.temp2 || 0),
            temp3: Number(item.temp3 || 0),
            temp4: Number(item.temp4 || 0),
        }));


        return graphData.length > 0 ? (
            <ResponsiveContainer width="100%" height={250}>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                        dataKey="timestamp"
                        tickFormatter={(value) =>
                            dayjs(value).format("DD-MM HH:mm")
                        }
                        label={{
                            value: "Time",
                            position: "insideBottom",
                            offset: -5,
                        }}
                    />

                    <YAxis
                        label={{
                            value: "Temp",
                            angle: -90,
                            position: "insideLeft",
                        }}
                    />

                    <Tooltip
                        labelFormatter={(label, payload) => {
                            const timestamp = payload?.[0]?.payload?.timestamp;

                            if (!timestamp) {
                                return label;
                            }

                            const date = dayjs(timestamp);

                            return date.isValid()
                                ? date.format("DD-MM-YYYY HH:mm:ss")
                                : timestamp;
                        }}
                        formatter={(value) => [`${value} °C`, "Temperature"]}
                    />
                    <Legend />

                    {["temp1", "temp2", "temp3", "temp4"].map((sensor, index) => (
                        <Line
                            key={sensor}
                            type="monotone"
                            dataKey={sensor}
                            stroke={["#ff7300", "#387908", "#0088FE", "#AA00FF"][index]}
                            strokeWidth={2}
                            name={sensor.toUpperCase()}
                            dot={false}
                            connectNulls
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        ) : (
            <div
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <img src={nodata} alt="No Data" style={{ width: 120, opacity: 0.7 }} />
                <p>No graph data available</p>
            </div>
        );

    }
}
